"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PassionForPerfection() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="230445" id="a-legacy-of-craft" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-40">
      {}
      <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-b from-background via-background to-accent/5 pointer-events-none z-0" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="absolute -inset-4 bg-primary/5 translate-x-4 translate-y-4 z-0" />
            
            <div className="relative z-10 overflow-hidden shadow-md bg-card border border-border">
              <img src="https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/Asphalt-Shingle-Roof-Installation-Services_.jpg" alt="Master craftsman at Protech Restoration LLC" className="w-full h-auto aspect-[3/4] object-cover grayscale contrast-125 brightness-90 hover:scale-105 transition-transform duration-700 ease-in-out" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent opacity-30 pointer-events-none mix-blend-overlay" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 relative transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 lg:translate-x-12 translate-y-12 lg:translate-y-0"}`}>
            {}
            <div className="absolute -top-24 -left-12 md:-left-24 text-[12rem] md:text-[20rem] leading-none font-default font-bold text-muted/5 select-none pointer-events-none z-0 tracking-tighter">
              PT
            </div>

            <div className="relative z-10 pl-0 lg:pl-8 border-l-0 lg:border-l-4 border-primary">
              <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold tracking-tighter uppercase mb-8 leading-[0.9]">
                A Legacy <br />
                <span className="text-primary">Of</span> <br />
                Craft
              </h2>
              
              <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-default max-w-2xl font-light leading-relaxed">
                <p>
                  At Protech Restoration LLC, we don't just repair homes. We fortify them using industrial-grade materials and architectural precision. Every siding panel and roofing shingle is installed with a commitment to durability and aesthetic excellence.
                </p>
                <p>
                  Our craftsmen combine decades of experience with modern engineering to protect your investment. From custom decks to energy-efficient windows, we ensure your home stands as a testament to quality that lasts for generations.
                </p>
              </div>

              <div className="mt-12">
                <Button asChild size="lg" variant="default" className="rounded-lg font-default uppercase tracking-widest h-14 px-8 text-sm hover:bg-primary/90 transition-colors">
                  
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}